import { fetchClient } from "@/api/api";
import type {
	FCConfigAdminOutput,
	patchFcConfigInput,
	patchFcConfigOutput,
} from "@/api/custom_types";
import useApiError from "@/hooks/useApiError";
import type { ApiError } from "@/utils/fetching";
import type { CustomMutationHook, CustomQueryHook } from "@/utils/react-query";
import { invalidateQueries } from "@/utils/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";
import { FC_CONFIG_SERVICE_KEYS } from "./keys";

export const useGetFcConfig: CustomQueryHook<
	FCConfigAdminOutput,
	undefined,
	FCConfigAdminOutput
> = (options) => {
	return useQuery({
		...options,
		queryKey: FC_CONFIG_SERVICE_KEYS.useGetFcConfig(),
		queryFn: async () => {
			const { data, error } = await fetchClient.GET("/v1/fc/fc-config/", {
				throwOnError: true,
			});
			if (error) throw error;
			return data;
		},
	});
};

export const usePatchFcConfig: CustomMutationHook<
	patchFcConfigInput,
	patchFcConfigOutput
> = () => {
	const { toastApiError } = useApiError();

	return useMutation<patchFcConfigOutput, ApiError, patchFcConfigInput>({
		mutationKey: FC_CONFIG_SERVICE_KEYS.usePatchFcConfig(),
		mutationFn: async (body) => {
			const { data, error } = await fetchClient.POST("/v1/fc/fc-config/", {
				body,
				throwOnError: true,
			});
			if (error) throw error;
			return data;
		},
		onSuccess: () => {
			invalidateQueries(FC_CONFIG_SERVICE_KEYS.useGetFcConfig());
		},
		onError: (error) => {
			toastApiError(error);
		},
	});
};
